"use client"

import {
  EntityDetailSkeleton,
  ArtifactCanvasBody,
  ArtifactCanvasDismissAction,
  ArtifactCanvasFooterBar,
  PersonProfileReadView,
  useProfileById,
} from '@yeshuman/sdk'
import { SaveToBriefControl } from './save-to-brief-control'

export type TalentProfilePreviewCanvasProps = {
  profileId: string
  profileName?: string
  onClose: () => void
}

export function TalentProfilePreviewCanvas({
  profileId,
  profileName,
  onClose,
}: TalentProfilePreviewCanvasProps) {
  const { profile, isLoading, error } = useProfileById(profileId)

  if (isLoading) {
    return (
      <>
        <ArtifactCanvasBody className="min-h-0 flex-1 overflow-y-auto">
          <EntityDetailSkeleton variant="compact" withPageContainer={false} ariaLabel="Loading profile" />
        </ArtifactCanvasBody>
        <ArtifactCanvasFooterBar
          footerClassName="shrink-0"
          actions={<ArtifactCanvasDismissAction onClose={onClose} label="Close" />}
        />
      </>
    )
  }

  if (error || !profile) {
    return (
      <>
        <ArtifactCanvasBody className="min-h-0 flex-1 overflow-y-auto">
          <p className="text-sm text-destructive">
            {error instanceof Error ? error.message : 'Profile not found'}
          </p>
        </ArtifactCanvasBody>
        <ArtifactCanvasFooterBar
          footerClassName="shrink-0"
          actions={<ArtifactCanvasDismissAction onClose={onClose} label="Close" />}
        />
      </>
    )
  }

  return (
    <>
      <ArtifactCanvasBody className="min-h-0 flex-1 overflow-y-auto">
        <PersonProfileReadView profile={profile} />
      </ArtifactCanvasBody>
      <ArtifactCanvasFooterBar
        className="flex-wrap"
        footerClassName="shrink-0"
        leading={
          <SaveToBriefControl profileId={profileId} profileName={profileName} stopPropagation={false} />
        }
        actions={<ArtifactCanvasDismissAction onClose={onClose} label="Close" />}
      />
    </>
  )
}
